

const LoadingSpinner = () => {
  return (
    // add logo in centre not spinning
    <div className="flex items-center justify-center">
  <div className="relative h-20 w-20">
    <div className="animate-spin rounded-full h-full w-full border-t-4 border-b-0 border-primary transition-all duration-300">
    </div>
    {/* <img 
      src="/logo192.png" 
      alt="Loading..." 
      className="absolute inset-0 h-14 w-auto m-auto"
    /> */}
  </div>
</div>
  );
};

export default LoadingSpinner;
